/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * User-applied annotation, set via the viewer after a capture is reviewed.
 * @export
 * @interface CaptureAnnotation
 */
export interface CaptureAnnotation {
    [key: string]: any | any;
    /**
     * 
     */
    nickname?: string | null;
    /**
     * 
     */
    species?: string | null;
    /**
     * 
     */
    angler?: string | null;
    /**
     * 
     */
    guide?: string | null;
    /**
     * 
     */
    notes?: string | null;
    /**
     * 
     */
    measuredWeightGrams?: number | null;
    /**
     * 
     */
    measuredLengthMm?: number | null;
    /**
     * 
     */
    userEnteredTime?: number | null;
    /**
     * 
     */
    captureDisplayCode?: string | null;
    /**
     * 
     */
    annotatedAt?: Date | null;
    /**
     * 
     */
    netStatus?: CaptureAnnotationNetStatusEnum | null;
}


/**
 * @export
 */
export const CaptureAnnotationNetStatusEnum = {
    NotWorking: 'not_working',
} as const;
export type CaptureAnnotationNetStatusEnum = typeof CaptureAnnotationNetStatusEnum[keyof typeof CaptureAnnotationNetStatusEnum];


/**
 * Check if a given object implements the CaptureAnnotation interface.
 */
export function instanceOfCaptureAnnotation(value: object): value is CaptureAnnotation {
    return true;
}

export function CaptureAnnotationFromJSON(json: any): CaptureAnnotation {
    return CaptureAnnotationFromJSONTyped(json, false);
}

export function CaptureAnnotationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureAnnotation {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'nickname': json['nickname'] === undefined ? undefined : json['nickname'] === null ? null : json['nickname'],
        'species': json['species'] === undefined ? undefined : json['species'] === null ? null : json['species'],
        'angler': json['angler'] === undefined ? undefined : json['angler'] === null ? null : json['angler'],
        'guide': json['guide'] === undefined ? undefined : json['guide'] === null ? null : json['guide'],
        'notes': json['notes'] === undefined ? undefined : json['notes'] === null ? null : json['notes'],
        'measuredWeightGrams': json['measured_weight_grams'] === undefined ? undefined : json['measured_weight_grams'] === null ? null : json['measured_weight_grams'],
        'measuredLengthMm': json['measured_length_mm'] === undefined ? undefined : json['measured_length_mm'] === null ? null : json['measured_length_mm'],
        'userEnteredTime': json['user_entered_time'] === undefined ? undefined : json['user_entered_time'] === null ? null : json['user_entered_time'],
        'captureDisplayCode': json['capture_display_code'] === undefined ? undefined : json['capture_display_code'] === null ? null : json['capture_display_code'],
        'annotatedAt': json['annotated_at'] === undefined ? undefined : json['annotated_at'] === null ? null : (parseDateTime(json['annotated_at'])),
        'netStatus': json['net_status'] === undefined ? undefined : json['net_status'] === null ? null : json['net_status'],
    };
}

export function CaptureAnnotationToJSON(json: any): CaptureAnnotation {
    return CaptureAnnotationToJSONTyped(json, false);
}

export function CaptureAnnotationToJSONTyped(value?: CaptureAnnotation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'nickname': value['nickname'],
        'species': value['species'],
        'angler': value['angler'],
        'guide': value['guide'],
        'notes': value['notes'],
        'measured_weight_grams': value['measuredWeightGrams'],
        'measured_length_mm': value['measuredLengthMm'],
        'user_entered_time': value['userEnteredTime'],
        'capture_display_code': value['captureDisplayCode'],
        'annotated_at': value['annotatedAt'] == null ? value['annotatedAt'] : serializeDateTime(value['annotatedAt']),
        'net_status': value['netStatus'],
    };
}

